import { useQuery } from "react-query";

import { dropdownValuesService } from "services";
import { ProcessorSponsorPageName } from "types";

export type UseSponsorsQueryProps = {
	applicationId?: string;
	pageName?: ProcessorSponsorPageName;
	options?: any;
};

const useSponsorsQuery = ({
	applicationId,
	pageName,
	options,
}: UseSponsorsQueryProps = {}) => {
	return useQuery(
		["sponsors", applicationId, pageName],
		() => dropdownValuesService.getSponsors(applicationId, pageName),
		options,
	);
};

export default useSponsorsQuery;
